import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const Thumbnail = styled.div`
  position: relative;
`;

export const PlayIconWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
`;

export const VideoWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const VideoFrame = styled.iframe`
  width: 100%;
  height: 100%;
  flex: 1;
`;

export const VideoChildrenContainer = styled.div`
  font-size: small;
  font-style: italic;
  margin-bottom: 20px;
  ${media.mediumUp`
    margin-bottom: 30px;
    `}
`;
